<template>
  <v-row class="ma-0 pa-0" v-if="!!sections && !!sections.length">
    <v-col
      cols="12"
      class="ma-0 pa-0"
      v-for="(section, index) in sections"
      :key="section.text + index"
    >
      <vetalfa-section-title
        v-if="section.style == 1"
        :prop="section.text"
        :references="section.references"
      >
      </vetalfa-section-title>
      <vetalfa-section-item-title
        class="py-1"
        v-else-if="section.style == 2 && !modifySectionItemTitle"
        :prop="section.text"
      >
      </vetalfa-section-item-title>
      <v-row
        v-else-if="section.style == 2 && !!modifySectionItemTitle"
        class="pl-2 ma-0 pa-0 mb-2 primary--text"
        justify="start"
        align="center"
      >
        <p class="text-start ma-0 pa-0">
          {{ section.text }}
        </p>
      </v-row>
      <vetalfa-section-item
        :index="getItemIndex(index)"
        v-else-if="section.style == 3"
        :references="section.references"
        :prop="section.text"
      >
      </vetalfa-section-item>
      <vetalfa-section-sub-item
        v-else-if="section.style == 4"
        :references="section.references"
        class="ml-5 pl-5 pr-3"
        :prop="section.text"
      >
      </vetalfa-section-sub-item>
      <vetalfa-simple-table
        v-else-if="section.style == 5"
        :table="section.table"
        class="my-2"
      >
      </vetalfa-simple-table>
      <vetalfa-carousel
        v-else-if="section.style == 6"
        :contain="true"
        class="my-5 mx-3 ma-0 pa-0"
        :items="section.photos"
        :text="section.text"
        expandCarousel
        flatCard
      ></vetalfa-carousel>
      <vetalfa-section-paragraph
        class="px-2"
        v-else-if="section.style == 7"
        :prop="section.text"
        :nextStyle="sections[index + 1] ? sections[index + 1].style : null"
      >
      </vetalfa-section-paragraph>
      <vetalfa-vimeo
        :url="section.text"
        v-else-if="section.style == 8"
      ></vetalfa-vimeo>
    </v-col>
  </v-row>
</template>

<style>
</style>

<script>
import {} from "@mdi/js";
import ReferencesDialog from "@/components/ReferencesDialog.vue";
import Vimeo from "@/components/Vimeo.vue";
export default {
  name: "Sections",
  components: {
    "vetalfa-vimeo": Vimeo,
    "vetalfa-references-dialog": ReferencesDialog,
  },
  props: {
    sections: {
      type: Array,
      default: [],
      required: true,
    },
    modifySectionItemTitle: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  methods: {
    isDoseReference(section) {
      return (
        !!section.references &&
        section.references.length == 1 &&
        !!section.references[0].dose
      );
    },
    getItemIndex(index) {
      try {
        return [3, 4].includes(this.sections[index - 1].style) &&
          !this.isDoseReference(this.sections[index - 1])
          ? 1
          : 0;
      } catch (error) {
        return 0;
      }
    },
  },
  watch: {},
  data() {
    return {};
  },
  created() {},
};
</script>